import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMaterialOutlinedInput,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoToggleOutlined,
    showErrorMessage, showSuccessMessage, showWarningMessage
} from '@moeindal/base-raiko-panel-components'
import {FundService} from "../../serverService/fund/FundService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {stringIsEmpty} from "../../util/VariableChecker";

const FundSuperAdmin = () => {

    const service = new FundService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [info, setInfo] = useState({
        createdAt: null,
        createdByAdmin: "",
        createdByManager: "",
        enabled: "",
        firstName: "",
        lastName: "",
        fundId: "",
        fundName: "",
        nationalCode: "",
        phoneNumber: "",
        totalOwner: "",
        password: "",
        username: ""
    })


    useEffect(() => {
        getSuperAdminInfo()
    }, [])

    function getSuperAdminInfo() {
        loading.show()
        service.getSuperAdminInfo()
            .then(response => {
                setInfo({
                    ...info,
                    ...response
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateSuperAdminInfo() {
        if (checkFieldsInfo()) {
            loading.show()
            if (info.createdAt) {
                service.updateSuperAdmin(
                    info
                ).then(response => {
                    showSuccessMessage("اطلاعات مدیر با موفقیت بروزرسانی شد.")
                }).catch(reason => {
                    showErrorMessage(detectServerErrorMessage(reason))
                }).finally(_ => {
                    loading.hide()
                })
            } else {
                service.createSuperAdmin(
                    info
                ).then(response => {
                    showSuccessMessage("مدیر کل با موفقیت ایجاد شد.")
                }).catch(reason => {
                    showErrorMessage(detectServerErrorMessage(reason))
                }).finally(_ => {
                    loading.hide()
                })
            }
        }
    }

    function checkFieldsInfo() {
        let state = false
        let message = ""

        if (stringIsEmpty(info.firstName))
            message = "لطفا نام ادمین را وارد نمایید."
        else if (stringIsEmpty(info.lastName))
            message = "لطفا نام خانوادگی ادمین را وارد نمایید."
        else if (stringIsEmpty(info.username))
            message = "لطفا نام کاربری ادمین را وارد نمایید."
        else if (stringIsEmpty(info.phoneNumber))
            message = "لطفا شماره همراه ادمین را وارد نمایید."
        else if (stringIsEmpty(info.nationalCode))
            message = "لطفا کد ملی ادمین را وارد نمایید."
        else
            state = true

        if (message && message.length > 0)
            showWarningMessage(message)

        return state
    }

    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.FundsSuperAdmin.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Funds.name,
                        ""
                    ),
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.FundsSuperAdmin.name,
                        RouteHelper.FundsSuperAdmin.url
                    )
                ]}/>

                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                        subTitle={""}
                        hasActionButton
                        actionButtonOnclick={handleUpdateSuperAdminInfo}
                    >
                        <RaikoGridOneColumn>
                            <RaikoGridThreeColumn>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام"}
                                    value={info.firstName}
                                    setValue={value => {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                firstName: value
                                            }
                                        })
                                    }}
                                />
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام خانوادگی"}
                                    value={info.lastName}
                                    setValue={value => {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                lastName: value
                                            }
                                        })
                                    }}
                                />
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام کاربری"}
                                    value={info.username}
                                    setValue={value => {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                username: value
                                            }
                                        })
                                    }}
                                />
                                <RaikoNumberInputOutlined
                                    labelText={"کدملی"}
                                    value={info.nationalCode}
                                    setValue={value => {
                                        if (!value || value.toString().length <= 10)
                                            setInfo(prev => {
                                                return {
                                                    ...prev,
                                                    nationalCode: value
                                                }
                                            })
                                    }}
                                />
                                <RaikoMobileInputOutlined
                                    labelText={"کدملی"}
                                    value={info.phoneNumber}
                                    setValue={value => {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                phoneNumber: value
                                            }
                                        })
                                    }}
                                />
                                <RaikoMaterialOutlinedInput
                                    labelText={"رمز عبور"}
                                    value={info.password}
                                    setValue={value => {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                password: value
                                            }
                                        })
                                    }}
                                />
                            </RaikoGridThreeColumn>
                            <RaikoToggleOutlined
                                checked={info.enabled}
                                setChecked={value => {
                                    setInfo(prev => {
                                        return {
                                            ...prev,
                                            enabled: value
                                        }
                                    })
                                }}
                                labelText={"وضعیت"}/>
                        </RaikoGridOneColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>

        </>
    )
}

export default FundSuperAdmin;